// Central source of truth for which roles can access which console routes.
// Consumed by both the sidebar NAV filter (ConsoleLayout.jsx) and the
// <RoleGuard> route wrapper (App.js) so the two can never drift out of sync.
//
//   super_admin  → sees everything (incl. Revenue)
//   tenant_admin → sees everything except super-admin-only pages (Revenue)
//   operator     → sees everything except Tenant/Brand + super-admin pages
//   scheduler    → restricted to programming surfaces (see list below)
//
// Entries omitted from this map are assumed public to every authenticated
// role (e.g. /console/dashboard).

export const ROUTE_ROLES = {
  "/console/assets":        ["tenant_admin", "super_admin", "scheduler", "operator"],
  "/console/clips":         ["tenant_admin", "super_admin", "scheduler"],
  "/console/magic-wall":    ["tenant_admin", "super_admin", "scheduler", "operator"],
  "/console/epg":           ["tenant_admin", "super_admin", "operator"],
  "/console/polls":         ["tenant_admin", "super_admin", "operator"],
  "/console/monitoring":    ["tenant_admin", "super_admin", "operator"],
  "/console/pricing":       ["tenant_admin", "super_admin", "operator"],
  "/console/billing":       ["tenant_admin", "super_admin", "operator"],
  "/console/hardware":      ["tenant_admin", "super_admin", "operator"],
  "/console/tenant":        ["tenant_admin", "super_admin"],
  "/console/users":         ["tenant_admin", "super_admin", "operator"],
  "/console/admin/revenue": ["super_admin"],
  "/console/admin/tenants": ["super_admin"],
  "/console/admin/audit-logs": ["super_admin"],
};

// Roles for which a NAV/route entry (without an explicit role list) should
// still be visible. All authenticated console users qualify.
export const ALL_ROLES = ["super_admin", "tenant_admin", "scheduler", "operator"];

/** True when `role` is allowed to access `path`. Unknown paths default to open. */
export function canAccessRoute(path, role) {
  const allow = ROUTE_ROLES[path];
  if (!allow) return true;
  return allow.includes(role);
}
